export default __webpack_public_path__ + "static/sales-training-form-bg-e7fba8863bd08363504f8dbdffad28a0.png";